import { z } from "zod";
import uuid from "./uuid";

export default z.object({
  id: z.string(),
  name: z.string(),
  city: z.string(),
  picture: uuid,
});
